import React from 'react';
import { Page } from '../Page';
import { AlertTriangle } from 'lucide-react';
import { SupplementCallout } from '../SupplementCallout';
export function Page3() {
  return <Page pageNumber={9} variant="light" data-id="element-836" data-mp="tcirhjg6tdqs">
      <div className="flex flex-col h-full" data-id="element-837" data-mp="tbh4qhpt72t8">
        <div className="h-[160px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-838" data-mp="tev6bnqnf7zm">
          <img src="https://images.unsplash.com/photo-1532550907401-a500c9a57435?w=1000&q=80" alt="Grilled chicken and protein foods" className="w-full h-full object-cover object-center" data-id="element-839" data-mp="y9se6rc6zbax" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-840" data-mp="am0yrevcui5f" />
        </div>

        <div className="mb-8" data-id="element-841" data-mp="emuqkjbx4h3l">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-842" data-mp="eo5qg828t4pf">
            The Essentials
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-843" data-mp="5my66twka4ec">
            <span className="text-tealslate" data-id="element-844" data-mp="5p0sp3yi9feb">Protein</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-845" data-mp="26bcjsani9und" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-846" data-mp="21ecgg7i1j5zy">
          <div data-id="element-847" data-mp="21fx73m18i4sj">
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-6" data-id="element-848" data-mp="2fdlscuz7rdy4">
              GLP-1 medications cause rapid weight loss. Without adequate
              protein, a significant portion of that weight loss comes from
              muscle, not just fat. Protein preserves your muscle mass, keeps
              you feeling full, and supports recovery.
            </p>
            <div className="bg-tealslate/10 border border-tealslate/30 p-4" data-id="element-849" data-mp="1ip63l13xh8m2">
              <h3 className="text-[10px] font-bold text-tealslate uppercase tracking-wider mb-2" data-id="element-850" data-mp="1wfhxn5k2phfu">
                Experienced Lifters
              </h3>
              <p className="text-[#1F1F1F] font-bold text-sm mb-1" data-id="element-851" data-mp="13yfalpqlo3hd">
                0.7 to 1g per pound of bodyweight per day
              </p>
              <div className="flex gap-2 mt-2" data-id="element-852" data-mp="yykk3naqlfwu">
                <span className="bg-tealslate/20 px-2 py-1 text-[10px] text-[#3B3B3B]" data-id="element-853" data-mp="2z1lfxu1gw1sv">
                  160 lbs → <strong className="text-tealslate" data-id="element-854" data-mp="340olrgp9uc1w">112–160g</strong>
                  /day
                </span>
                <span className="bg-tealslate/20 px-2 py-1 text-[10px] text-[#3B3B3B]" data-id="element-855" data-mp="38rn6cshalway">
                  200 lbs → <strong className="text-tealslate" data-id="element-856" data-mp="3dq85eokt69xt">140–200g</strong>
                  /day
                </span>
              </div>
            </div>
          </div>
          <div data-id="element-857" data-mp="2g4u1pz0s8cvo">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 mb-6" data-id="element-858" data-mp="2l1stiawz47qp">
              <h3 className="text-[10px] font-bold text-tealslate uppercase tracking-wider mb-2" data-id="element-859" data-mp="2l3wuajzksqmr">
                Non-Gym Goers / Beginners
              </h3>
              <p className="text-[#1F1F1F] font-bold text-sm mb-1" data-id="element-860" data-mp="2u3jx9a7ye4hx">
                0.55g per pound of bodyweight per day
              </p>
              <div className="flex gap-2 mt-2" data-id="element-861" data-mp="5cr4ig8riwqn">
                <span className="bg-white/60 px-2 py-1 text-[10px] text-[#3B3B3B]" data-id="element-862" data-mp="9bi4qw8iyuhz">
                  160 lbs → <strong className="text-tealslate" data-id="element-863" data-mp="1tutxeove0yza">~88g</strong>/day
                </span>
                <span className="bg-white/60 px-2 py-1 text-[10px] text-[#3B3B3B]" data-id="element-864" data-mp="1ps722dzicvxc">
                  200 lbs → <strong className="text-tealslate" data-id="element-865" data-mp="1l1qpsx7fbgck">~110g</strong>
                  /day
                </span>
              </div>
            </div>
            <div className="border-l-4 border-tealslate pl-5" data-id="element-866" data-mp="1g2e26a8qa58x">
              <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-867" data-mp="1b42ti2u660sa">
                The 100g Target
              </h3>
              <p className="text-xs text-[#3B3B3B] leading-[1.8]" data-id="element-868" data-mp="163yao65sgtyw">
                Aim for a minimum of 100 grams of protein per day. This is the
                baseline required to protect your muscle mass while in a caloric
                deficit.
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-start gap-4 bg-[#EAEAE4] border-l-4 border-[#C4956A] px-5 py-4 mb-6" data-id="element-869" data-mp="2wgniqi6qapp7">
          <AlertTriangle className="w-5 h-5 text-[#C4956A] shrink-0 mt-0.5" data-id="element-870" data-mp="2riu91f67vdk6" />
          <div data-id="element-871" data-mp="1o8gg2xtyu22z">
            <h3 className="font-bold text-[#1F1F1F] text-sm mb-1" data-id="element-872" data-mp="1o7ybndx5ghjz">
              Hair Loss Warning
            </h3>
            <p className="text-xs text-[#3B3B3B] leading-[1.8]" data-id="element-873" data-mp="1t45h75lmvr1e">
              Hair loss occurs faster than muscle loss and is the earliest
              visible sign you are not getting enough protein. If you notice
              your hair falling out more than usual, you need more protein.
            </p>
          </div>
        </div>

        <SupplementCallout title="Protein Powder" description="If you struggle to hit your protein target through food alone, a whey or collagen protein supplement can bridge the gap. Look for 20-30g protein per serving with minimal added ingredients." data-id="element-874" data-mp="1a7x8tsxbr01v" />
      </div>
    </Page>;
}